import React, { Component } from "react";

import "HELPDESK/Components/QueryDetails/ViewRequestModal/VerticalStepper/verticalstepper.css";
import customerMicrophone from "HELPDESK/CommonResources/images/customerMicrophone.png";
import handIcon from "HELPDESK/CommonResources/images/handIcon.png";
import developmentIcon from "HELPDESK/CommonResources/images/developmentIcon.svg";
import closureConfirmationIcon from "HELPDESK/CommonResources/images/closureConfirmation.svg";
import closureIcon from "HELPDESK/CommonResources/images/customerMicrophone.png";
import { toast } from "react-toastify";
import HelpdeskApiCall from "HelpdeskApiCall";
import config from "config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class VerticalStepper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentQueryRequestId: this.props.currentQueryRequestId,
            transactionList: [],
        };
    }


    componentDidMount() {
        this.apiCallToGetTransactionHistory();
    }
    apiCallToGetTransactionHistory = async () => {
        // this.setState({
        //     executiveResponseFetching: true,
        // })
        const requestData = {
            serviceRequestId: this.state.currentQueryRequestId,
            // updatedBy: config.userId
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'helpDesk_getClientServiceRequestStatusHistory',
            requestData,
            '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetTransactionHistory();
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult.data;
                let sequenceArray = jsonResponse.APIResult.sequence;


                let sequenceObjectArray = [];
                sequenceArray.forEach((seq) => {
                    if (apiResult[seq]) {
                        sequenceObjectArray.push(apiResult[seq]);
                    }
                });

                this.setState({ transactionList: sequenceObjectArray });


            } else {
       
                toast.error(jsonResponse.message)
                this.setState({ transactionList: [] });
            }
        }
    }
    render() {
        // const steps = [
        //     { phase: "Consideration", title: "Service Request Opening", date: "Mon - 12th, Dec, 2025", status: "COMPLETED", customIcon: customerMicrophone },
        //     { phase: "Consideration", title: "Service Request Consideration", date: "Mon - 12th, Dec, 2025", status: "COMPLETED", customIcon: handIcon },
        //     { phase: "Development", title: "Development", date: "Mon - 12th, Dec, 2025", status: "IN_PROGRESS", customIcon: developmentIcon },
        //     { phase: "Development", title: "Closure Confirmation", date: "Mon - 12th, Dec, 2025", status: "NEW", customIcon: closureConfirmationIcon },
        //     // Closure from client side
        //     { phase: "Closure", title: "Clozure", date: "Mon - 12th, Dec, 2025", status: "NEW", customIcon: closureIcon }
        // ];
        const steps = {
            "Service Request Opening": {
                phase: "Consideration",
                title: "Service Request Opening",
                date: "Mon - 12th, Dec, 2025",
                status: "COMPLETED",
                customIcon: customerMicrophone,
            },
            "Service Request Consideration": {
                phase: "Consideration",
                title: "Service Request Consideration",
                date: "Mon - 12th, Dec, 2025",
                status: "COMPLETED",
                customIcon: handIcon,
            },
            "Development": {
                phase: "Development",
                title: "Development",
                date: "Mon - 12th, Dec, 2025",
                status: "IN_PROGRESS",
                customIcon: developmentIcon,
            },
            "Closer confirmation": {
                phase: "Closer Confirmation",
                title: "Closure confirmation",
                date: "Mon - 12th, Dec, 2025",
                status: "NEW",
                customIcon: closureConfirmationIcon,
            },
            // Closure from client side
            "Close": {
                phase: "Close",
                title: "Close",
                date: "Mon - 12th, Dec, 2025",
                status: "NEW",
                customIcon: closureIcon,
            }

        }

        return (
            <div className="container my-4">

                {
                    this.state.transactionList.length > 0 &&
                    this.state.transactionList.map((transaction, index) => (
                        <div key={index} className="d-flex align-items-start mb-4">

                            <div className="ms-3">
                                {/* {index === 0 || (steps[transaction.statusName] && steps[index - 1]?.phase !== steps[transaction.statusName]?.phase) ? (
                                    <p className="vm_custom_overline1" style={{ color: '#8F9AA3', marginBottom: '10px' }}>
                                        Phase {Math.ceil((index +1))} - {steps[transaction.statusName]?.phase}
                                    </p>
                                ) : null} */}
                                <p className="vm_custom_overline1" style={{ color: '#8F9AA3', marginBottom: '10px' }}>
                                    Phase {Math.ceil((index + 1))} - {transaction.statusName}
                                </p>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: '7px', height: '100%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    
                                        {transaction?.statusHistory?.transitionStatus ? (
                                            <span className={`request-circle ${transaction?.statusHistory?.transitionStatus === "completed" ? "completed" : "new"}`}>
                                                ✔
                                            </span>
                                        ) : (
                                            <span className={`request-circle ${transaction?.isNextStatus === "true" ? "in-progress" : "new"}`}>
                                                ✔
                                            </span>
                                        )}

                                    </div>

                                    {/* Icon */}
                                    <div className="innerBoardStepper">
                                        {/* <img src={steps[transaction.statusName]?.customIcon} alt={transaction?.statusName} style={{ height: '24px', width: '24px', marginTop: '10px' }} /> */}
                                        <FontAwesomeIcon icon={transaction?.icons} alt={transaction?.statusName} style={{ height: '24px', width: '24px', marginTop: '10px' }} />

                                        <p className="vm_custom_subtitle5" style={{ color: '#000000' }}>{transaction?.statusLabelName}</p>
                                        <p className="vm_custom_body4" style={{ color: '#1E1E1E' }}>Service Request created on</p>

                                        <p className="vm_custom_body4" style={{ color: '#808080' }}>{transaction?.statusHistory?.readableCreatedOn}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default VerticalStepper;
